import {
  FIND_USER_IN_PIANO,
  PASSWORDLESS_REGISTER,
  PERSONALIZATION_API_HOST,
  PERSONALIZATION_API_KEY,
} from '@/app_lib/utils/personalizationApi/constants';

interface PasswordlessRegisterResponse {
  pianoUid: string;
  accessToken: string;
  expiresIn: Date;
}

export async function subscribeUser(
  email: string,
  country: string,
  formName: string[],
  reCaptchaToken: string | undefined,
  pagePath: string,
  bypassReCaptcha?: boolean,
  signupConsent?: boolean,
  signupSource?: string,
  signupMedium?: string,
  signupCampaign?: string,
  source?: string,
  medium?: string,
  campaign?: string,
  pianoUid?: string,
) {
  const body = {
    bypassReCaptcha,
    campaign,
    country,
    email,
    formName,
    medium,
    pagePath,
    pianoUid,
    reCaptchaToken,
    signupCampaign,
    signupConsent,
    signupMedium,
    signupSource,
    source,
  };

  const response = await fetch(`${PERSONALIZATION_API_HOST}/subscribeUser`, {
    body: JSON.stringify(body),
    headers: {
      'x-api-key': PERSONALIZATION_API_KEY,
    },
    method: 'POST',
  });

  if (!response.ok) {
    throw new Error('API error');
  }

  return true;
}

export async function passwordlessRegister(email: string, registrationConsent: string) {
  const url = `${PASSWORDLESS_REGISTER}?email=${email}&registrationConsent=${registrationConsent}`;
  const response = await fetch(url, {
    headers: {
      'x-api-key': PERSONALIZATION_API_KEY,
    },
    method: 'POST',
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return (await response.json()) as PasswordlessRegisterResponse;
}

export async function findUserInPiano(email: string) {
  const url = `${FIND_USER_IN_PIANO}?email=${email}`;
  const response = await fetch(url, {
    headers: {
      'x-api-key': PERSONALIZATION_API_KEY,
    },
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }
  const message = (await response.json()) as { message: string };

  return message.message !== 'false';
}
